import { TFunction } from 'i18next';

import { LocationAddressFilterType } from '@/entities/location';
import { ConsignmentStatusCode, CONSIGNMENT_STATUS } from '@/entities/consignments';
import type { SelectOption } from '@/shared/ui';

import { ConsignmentFormValues } from '../model';

export type AllowedStartingPointTypes =
  | typeof LocationAddressFilterType.CUSTOMER_ADDRESS
  | typeof LocationAddressFilterType.ARRIVAL_PORT_TRANSSHIPMENT
  | typeof LocationAddressFilterType.ARRIVAL_DELIVERY_OR_PICKUP_AT_SITE;

export type AllowedServiceTypes =
  | typeof LocationAddressFilterType.CUSTOMER_ADDRESS
  | typeof LocationAddressFilterType.WAREHOUSE_PICKUP
  | typeof LocationAddressFilterType.STORAGE;

export const getStartingPointTypeOptions = (t: TFunction): SelectOption<AllowedStartingPointTypes>[] => [
  {
    value: LocationAddressFilterType.CUSTOMER_ADDRESS,
    label: t('arrivalType.C')
  },
  {
    value: LocationAddressFilterType.ARRIVAL_PORT_TRANSSHIPMENT,
    label: t('arrivalType.P')
  },
  {
    value: LocationAddressFilterType.ARRIVAL_DELIVERY_OR_PICKUP_AT_SITE,
    label: t('arrivalType.X')
  }
];
//requestStatusName
export const getServiceTypeOptions = (t: TFunction): SelectOption<AllowedServiceTypes>[] => [
  {
    value: LocationAddressFilterType.CUSTOMER_ADDRESS,
    label: t('serviceType.D')
  },
  {
    value: LocationAddressFilterType.WAREHOUSE_PICKUP,
    label: t('serviceType.P')
  },
  {
    value: LocationAddressFilterType.STORAGE,
    label: t('serviceType.S')
  }
];

export const getRequestStatusOptions = (t: TFunction): SelectOption<ConsignmentStatusCode>[] => [
  {
    value: CONSIGNMENT_STATUS.AC,
    label: t('requestStatusName.AC')
  },
  {
    value: CONSIGNMENT_STATUS.CA,
    label: t('requestStatusName.CA')
  },
  {
    value: CONSIGNMENT_STATUS.CL,
    label: t('requestStatusName.CL')
  },
  {
    value: CONSIGNMENT_STATUS.IP,
    label: t('requestStatusName.IP')
  },
  {
    value: CONSIGNMENT_STATUS.NR,
    label: t('requestStatusName.NR')
  },
  {
    value: CONSIGNMENT_STATUS.OH,
    label: t('requestStatusName.OH')
  }
];

export const getPriorityOptions = (t: TFunction): SelectOption<ConsignmentFormValues['priority']>[] => [
  {
    value: 'normal',
    label: t('consignment.priority.normal', 'Normal')
  },
  {
    value: 'high',
    label: t('consignment.priority.high', 'High')
  },
  {
    value: 'urgent',
    label: t('consignment.priority.urgent', 'Urgent')
  }
];
